var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNovaPoshtaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15709_1090)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4294 5.32949C14.4838 5.31214 14.5555 5.34684 14.6271 5.44227C14.6271 5.44227 14.6271 5.44226 17.8658 8.64034C18.055 8.83118 18.055 9.12034 17.8658 9.26202C17.8658 9.26202 17.8658 9.26202 14.6271 12.5093C14.5555 12.6047 14.4838 12.6278 14.4294 12.5989C14.3749 12.57 14.3405 12.4861 14.3405 12.3647V5.53769C14.3405 5.41913 14.3749 5.34684 14.4294 5.32949Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8892 0H9.11849L9.33918 0.0925305C9.33918 0.0925305 9.33918 0.0925303 12.6725 3.43518C12.8158 3.62602 12.767 3.7706 12.5291 3.7706C12.5291 3.7706 12.5291 3.7706 11.1477 3.7706C10.9098 3.7706 10.7206 3.96145 10.7206 4.20145C10.7206 4.20145 10.7206 4.20145 10.7206 6.68241C10.7206 6.92241 10.5286 7.11325 10.242 7.11325C10.242 7.11325 10.242 7.11325 7.81442 7.11325C7.57653 7.11325 7.3845 6.92241 7.3845 6.68241C7.3845 6.68241 7.3845 6.68241 7.3845 4.20145C7.3845 3.96145 7.19534 3.7706 6.95459 3.7706H5.47855C5.24066 3.7706 5.19194 3.62602 5.33524 3.43518C5.33524 3.43518 5.33524 3.43518 8.67138 0.0925305L8.8892 0Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66717 5.25676C3.72736 5.28568 3.76462 5.36953 3.76462 5.49098V12.4597C3.76462 12.5811 3.72736 12.6534 3.66717 12.6765C3.60985 12.6997 3.52673 12.6765 3.42929 12.6042C3.42929 12.6042 3.42929 12.6042 0.141872 9.26158C-0.0472906 9.1199 -0.0472906 8.83074 0.141872 8.6399C0.141872 8.6399 0.141872 8.6399 3.42929 5.3464C3.52673 5.25098 3.60985 5.22785 3.66717 5.25676Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.81441 10.7422C7.81441 10.7422 7.81441 10.7422 10.242 10.7422C10.5286 10.7422 10.7206 10.933 10.7206 11.173C10.7206 11.173 10.7206 11.173 10.7206 13.7986C10.7206 14.0848 10.9098 14.2757 11.1477 14.2757H12.4346C12.6725 14.2757 12.767 14.4174 12.5779 14.5619C12.5779 14.5619 12.5779 14.5619 9.33918 17.8554C9.24173 17.9509 9.12422 18 9.00385 18C8.88634 18 8.76596 17.9509 8.67138 17.8554C8.67138 17.8554 8.67138 17.8554 5.43269 14.5619C5.24066 14.4174 5.33524 14.2757 5.57313 14.2757C5.57313 14.2757 5.57313 14.2757 6.95458 14.2757C7.19534 14.2757 7.3845 14.0848 7.3845 13.7986C7.3845 13.7986 7.3845 13.7986 7.3845 11.173C7.3845 10.933 7.57653 10.7422 7.81441 10.7422Z",
    fill: "#ED1C24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15709_1090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovaPoshtaLogo);
export default __webpack_public_path__ + "static/media/NovaPoshtaLogo.3d6b484647d01d25f4b9bd6650732c79.svg";
export { ForwardRef as ReactComponent };